import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy} from '@angular/core';
import {IonContent} from '@ionic/angular';

@Component({
  selector: 'app-scroll-to-top',
  templateUrl: './scroll-to-top.component.html',
  styleUrls: ['./scroll-to-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {'slot': 'fixed'},
  standalone: false
})
export class ScrollToTopComponent implements AfterViewInit, OnDestroy {
  @Input() content?: IonContent;

  visible = false;

  private scrollElement?: HTMLElement;
  private destroyed = false;

  constructor(private readonly changeDetectorRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    void this.bindScrollElement();
  }

  ngOnDestroy(): void {
    this.destroyed = true;
    this.scrollElement?.removeEventListener('scroll', this.updateVisibility);
  }

  scrollToTop(): void {
    if (this.content) {
      void this.content.scrollToTop(300);
    }
  }

  private async bindScrollElement(): Promise<void> {
    if (!this.content) {
      return;
    }

    const scrollElement = await this.content.getScrollElement();
    if (this.destroyed) {
      return;
    }

    this.scrollElement = scrollElement;
    this.scrollElement.addEventListener('scroll', this.updateVisibility, {passive: true});
    this.updateVisibility();
  }

  private readonly updateVisibility = (): void => {
    const visible = (this.scrollElement?.scrollTop ?? 0) > 400;
    if (visible === this.visible) {
      return;
    }

    this.visible = visible;
    this.changeDetectorRef.markForCheck();
  };
}
